/* ADMIN */
import '../../vendor/wad-commons/wad-admin/asset/wad/js/wadadmin';

/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/admin-cms.js'; */
import './submit-workshop';
